import { render, staticRenderFns } from "./TgsqForm.vue?vue&type=template&id=dd4f34ee&scoped=true"
import script from "./TgsqForm.vue?vue&type=script&lang=js"
export * from "./TgsqForm.vue?vue&type=script&lang=js"
import style0 from "./TgsqForm.vue?vue&type=style&index=0&id=dd4f34ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4f34ee",
  null
  
)

export default component.exports